import { useMutation, useQueryClient } from "@tanstack/react-query";

import { listingsApi, type UpdateListingInput } from "@/features/listings/services/listings.api";

export function useUpdateListing() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateListingInput }) =>
      listingsApi.updateListing(id, input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["listings", "mine"] });
      void queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  });
}

export function useDeleteListing() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => listingsApi.deleteListing(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["listings", "mine"] });
      void queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  });
}
